import Funnel from "@/components/Funnel";
import Seo from "@/lib/seo/Seo";
import { getSeoForPath } from "@/lib/seo/routes.mjs";

const QUESTIONS = [
  {
    label: "What type of business do you own?",
    options: [
      "Restaurant / Deli",
      "Convenience Store",
      "Retail Store",
      "Smoke Shop / Market",
      "Service Business",
      "Other",
    ],
  },
  {
    label: "What POS system are you currently using?",
    options: [
      "Clover",
      "Square",
      "Toast",
      "Lightspeed",
      "I do not currently have a POS",
      "Other",
    ],
  },
  {
    label: "What is your approximate monthly card volume?",
    options: [
      "Under $10,000",
      "$10,000 – $25,000",
      "$25,000 – $50,000",
      "$50,000 – $100,000",
      "Over $100,000",
      "Not sure",
    ],
  },
  {
    label: "How soon are you looking to upgrade or get a new POS system?",
    options: [
      "As soon as possible",
      "Within 30 days",
      "Within 60–90 days",
      "I’m just exploring options",
      "Not sure yet",
    ],
  },
];

export default function FreePosFunnel() {
  return (
    <div data-prerender-ready="true">
      <Seo {...getSeoForPath("/free-pos-offer")} />
      <Funnel
        slug="free-pos-offer"
        accentBadge="Free POS Program"
        hero="See If Your Business Qualifies for a Free POS System"
        subtitle="Answer a few quick questions and a Swipetronics specialist will review your business to see what POS options may be available."
        questions={QUESTIONS}
        finalTitle="Almost done — where should we send your POS review?"
        eventName="FreePosLead"
      />
    </div>
  );
}
